<template>
  <div>
    <div v-for="item in items" v-bind:key="item.id">
      <div v-if="item.menu && (token !== null || item.type !== 'favorite')" @click="$emit('selectGenre', item)" class="flex items-center py-4 pr-2 border-b">
        <span class="text-link flex-grow" :class="fontWeight">{{ item.name }}</span>
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" class="text-body text-opacity-50"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.485281 10)"/></svg>
      </div>
      <div v-if="item.children">
        <genre-list-button
          class="ml-4"
          :items="item.children"
          @selectGenre="selectGenre" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GenreListButton from './GenreListButton'

export default {
  name: 'genre-list-button',
  components: {
    GenreListButton
  },
  props: {
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    fontWeight: {
      type: String,
      default: function () {
        return 'font-normal'
      }
    }
  },
  methods: {
    selectGenre: function (item) {
      this.$emit('selectGenre', item)
    }
  },
  computed: {
    ...mapGetters({
      token: 'user/getToken'
    })
  }
}
</script>
